const validator = require('validator');
const parsePhoneNumber = require('libphonenumber-js');

const USER_NAME_REGEX = /^[a-zA-Z0-9_\.]+$/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+/*-.])[A-Za-z\d@!@#$%^&*()_+/*-.]{8,}$/;
const PHONE_REGEX = /^(?:00|\+)[0-9\s.\/-]{8,20}$/;
const NAME_REGEX = /^[a-zA-ZÀ-ÿ\s\-'\.]+$/;
const URL_REGEX = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig;

const isEmail = email => validator.isEmail(email);

const trimPhoneNumber = phone => {
  if (!phone) return '';
  let phoneNumber = phone.replace(/(^|\+)|[^\d+]+/g, (_, group1) => group1 ? group1 : '');
  if (phoneNumber.startsWith('00') || phoneNumber.startsWith('+')) {
    phoneNumber = `+${Number(phoneNumber)}`;
  } else if (`${Number(phoneNumber)}`.length >= 11) {
    phoneNumber = `+${Number(phoneNumber)}`;
  } else {
    phoneNumber = `+1${Number(phoneNumber)}`;
  }
  return phoneNumber;
};

const parsePhone = phone => {
  if (!phone) return false;
  const trimmedPhone = trimPhoneNumber(phone);
  const phoneNumber = parsePhoneNumber(trimmedPhone);
  return phoneNumber
};

const isPhone = (phone) => {
  const phoneNumber = parsePhone(phone);
  return phoneNumber ? phoneNumber.isValid() : false;
}

const isUsername = (username) => {
  return USER_NAME_REGEX.test(username)
}

const hasUrl = (inputString) => {
  return URL_REGEX.test(inputString);
}

const isValidName = (inputString) => {
  return NAME_REGEX.test(inputString);
}

module.exports = {
  trimPhoneNumber,
  isEmail,
  parsePhone,
  isPhone,
  USER_NAME_REGEX,
  PASSWORD_REGEX,
  PHONE_REGEX,
  isUsername,
  NAME_REGEX,
  URL_REGEX,
  hasUrl,
  isValidName
}